/* Visina lepljivog zaglavlja -> CSS promenljiva, da se ispod njega
   mogu zakačiti drugi elementi (npr. pregled slike na telefonu). */
(function () {
  var top = document.getElementById("shopify-section-header");
  if (!top) return;
  function meri() {
    document.documentElement.style.setProperty("--topbar-h", Math.round(top.getBoundingClientRect().height) + "px");
  }
  meri();
  if (window.ResizeObserver) new ResizeObserver(meri).observe(top);
  window.addEventListener("resize", meri);
  window.addEventListener("load", meri);
})();

/* SENSEI tema — interakcije bez zavisnosti (vanilla JS) */
(function () {
  "use strict";

  /* ---------------- Mobilni meni ---------------- */
  var menu = document.querySelector("[data-mobile-menu]");
  document.querySelectorAll("[data-menu-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!menu) return;
      menu.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
  });
  document.querySelectorAll("[data-menu-close]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!menu) return;
      menu.classList.remove("is-open");
      document.body.style.overflow = "";
    });
  });

  /* ---------------- FAQ ---------------- */
  document.querySelectorAll("[data-faq-q]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var answer = btn.parentElement.nextElementSibling;
      var open = btn.getAttribute("aria-expanded") === "true";
      document.querySelectorAll("[data-faq-q]").forEach(function (other) {
        other.setAttribute("aria-expanded", "false");
        var a = other.parentElement.nextElementSibling;
        if (a) a.classList.remove("is-open");
      });
      if (!open) {
        btn.setAttribute("aria-expanded", "true");
        if (answer) answer.classList.add("is-open");
      }
    });
  });

  /* ---------------- Video recenzije ---------------- */
  var videoCards = document.querySelectorAll("[data-video-card]");
  videoCards.forEach(function (card) {
    card.addEventListener("click", function () {
      var video = card.querySelector("video");
      if (!video) return;
      videoCards.forEach(function (other) {
        if (other !== card) {
          var v = other.querySelector("video");
          if (v) v.pause();
          other.classList.remove("is-playing");
        }
      });
      if (video.paused) {
        video.play();
        card.classList.add("is-playing");
      } else {
        video.pause();
        card.classList.remove("is-playing");
      }
    });
    var v = card.querySelector("video");
    if (v) {
      v.addEventListener("ended", function () {
        card.classList.remove("is-playing");
      });
    }
  });

  /* ---------------- Prikaži sve recenzije ---------------- */
  var reviewsToggle = document.querySelector("[data-reviews-toggle]");
  if (reviewsToggle) {
    reviewsToggle.addEventListener("click", function () {
      var hidden = document.querySelectorAll("[data-review-extra]");
      var expanded = reviewsToggle.dataset.expanded === "true";
      hidden.forEach(function (item) {
        item.classList.toggle("is-hidden", expanded);
      });
      reviewsToggle.dataset.expanded = expanded ? "false" : "true";
      reviewsToggle.textContent = expanded
        ? "Prikaži sve recenzije"
        : "Sakrij recenzije";
    });
  }

  /* ---------------- Galerija proizvoda: karusel ---------------- */
  (function () {
    var g = document.querySelector("[data-gallery]");
    if (!g) return;
    var track = g.querySelector("[data-gallery-track]");
    var slides = [].slice.call(g.querySelectorAll(".gallery__slide"));
    /* tačkice + sličice sa strane (sličice su van same galerije, da ih prevlačenje ne pomera) */
    var dots = [].slice.call((g.parentElement || g).querySelectorAll("[data-gallery-dot]"));
    var thumbsBox = (g.parentElement || g).querySelector("[data-gallery-thumbs] .ss-thumbs__in");
    var prev = g.querySelector("[data-gallery-prev]");
    var next = g.querySelector("[data-gallery-next]");
    if (!track || slides.length < 2) return;

    var i = 0;

    function postavi(n, odmah) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      track.classList.toggle("is-dragging", !!odmah);
      /* u pikselima, ne procentima — procenti se računaju prema širini trake, a ona ume da varira */
      track.style.transform = "translateX(" + (-i * g.clientWidth) + "px)";
      dots.forEach(function (d) { d.classList.toggle("is-active", parseInt(d.dataset.galleryDot, 10) === i); });
      if (thumbsBox) {
        var akt = thumbsBox.querySelector(".is-active");
        if (akt) {
          var top = akt.offsetTop, bot = top + akt.offsetHeight;
          if (top < thumbsBox.scrollTop) thumbsBox.scrollTop = top;
          else if (bot > thumbsBox.scrollTop + thumbsBox.clientHeight) thumbsBox.scrollTop = bot - thumbsBox.clientHeight;
        }
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    dots.forEach(function (d) {
      d.addEventListener("click", function () { postavi(parseInt(d.dataset.galleryDot, 10)); });
    });
    if (prev) prev.addEventListener("click", function () { postavi(i - 1); });
    if (next) next.addEventListener("click", function () { postavi(i + 1); });
    g.setAttribute("tabindex", "0");
    g.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); postavi(i - 1); }
      if (e.key === "ArrowRight") { e.preventDefault(); postavi(i + 1); }
    });

    /* Prevlačenje prstom ili mišem */
    var x0 = null, pomak = 0;
    g.addEventListener("pointerdown", function (e) {
      if (e.button && e.button !== 0) return;
      x0 = e.clientX; pomak = 0;
      track.classList.add("is-dragging");
    });
    g.addEventListener("pointermove", function (e) {
      if (x0 === null) return;
      pomak = e.clientX - x0;
      track.style.transform = "translateX(" + (-i * g.clientWidth + pomak) + "px)";
    });
    function pusti() {
      if (x0 === null) return;
      var prag = Math.max(40, g.clientWidth * 0.12);
      var cilj = i;
      if (pomak <= -prag) cilj = i + 1;
      else if (pomak >= prag) cilj = i - 1;
      x0 = null; pomak = 0;
      track.classList.remove("is-dragging");
      postavi(cilj);
    }
    g.addEventListener("pointerup", pusti);
    g.addEventListener("pointercancel", pusti);
    g.addEventListener("pointerleave", pusti);

    window.addEventListener("resize", function () { postavi(i, true); });

    postavi(0, true);
    requestAnimationFrame(function () { track.classList.remove("is-dragging"); });

    /* Sama se menja (npr. personalizovani proizvod: data-gallery-autoplay="2000");
       posle dodira/klika kupca pauza 6 s, pa nastavlja */
    var ms = parseInt(g.getAttribute("data-gallery-autoplay"), 10);
    if (ms > 0) {
      var mirujeDo = 0;
      var odmor = function () { mirujeDo = Date.now() + 6000; };
      g.addEventListener("pointerdown", odmor);
      g.addEventListener("keydown", odmor);
      g.addEventListener("click", odmor);
      setInterval(function () {
        if (document.hidden || x0 !== null || Date.now() < mirujeDo || !g.offsetParent) return;
        postavi(i >= slides.length - 1 ? 0 : i + 1);
      }, ms);
    }
  })();

  /* ---------------- Varijante ---------------- */
  var form = document.querySelector("[data-product-form]");
  var variantSelect = document.querySelector("[data-variant-select]");
  if (form && variantSelect) {
    var priceEl = document.querySelector("[data-product-price]");
    var compareEl = document.querySelector("[data-product-compare]");
    var idInput = form.querySelector('input[name="id"]');
    var submitBtn = form.querySelector("[data-add-button]");
    variantSelect.addEventListener("change", function () {
      var opt = variantSelect.selectedOptions[0];
      if (!opt) return;
      if (idInput) idInput.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        if (opt.dataset.compare) {
          compareEl.textContent = opt.dataset.compare;
          compareEl.classList.remove("hidden");
        } else {
          compareEl.classList.add("hidden");
        }
      }
      var available = opt.dataset.available === "true";
      if (submitBtn) {
        submitBtn.disabled = !available;
        if (!available) submitBtn.textContent = "Nedostupno";
        else refreshAddLabel();
      }
      updateBuyNow();
    });
  }

  /* ---------------- Akcija 1 / 2 komada ---------------- */
  var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
  var packButtons = document.querySelectorAll("[data-pack]");
  var secondBlock = document.querySelector("[data-second-block]");
  var secondMode = "same";

  packButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      packButtons.forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
      if (qtyInput) qtyInput.value = btn.dataset.pack;
      if (secondBlock) secondBlock.classList.toggle("hidden", btn.dataset.pack !== "2");
      refreshAddLabel();
      updateBuyNow();
    });
  });

  document.querySelectorAll("[data-second-mode]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelectorAll("[data-second-mode]").forEach(function (b) {
        b.classList.remove("is-active");
      });
      btn.classList.add("is-active");
      secondMode = btn.dataset.secondMode;
      var fields = document.querySelector("[data-second-fields]");
      var note = document.querySelector("[data-second-note]");
      if (fields) fields.classList.toggle("hidden", secondMode !== "different");
      if (note) note.classList.toggle("hidden", secondMode === "different");
      refreshAddLabel();
      updateBuyNow();
    });
  });

  function selectedPack() {
    var active = document.querySelector("[data-pack].is-active");
    return active ? parseInt(active.dataset.pack, 10) : 1;
  }

  /* ---------------- Cropper + pregled ---------------- */
  var cropper = document.querySelector("[data-cropper]");
  var cropImg = cropper ? cropper.querySelector("[data-crop-img]") : null;
  var cropStage = cropper ? cropper.querySelector("[data-crop-stage]") : null;
  var zoomInput = cropper ? cropper.querySelector("[data-crop-zoom]") : null;
  var state = { target: null, file: null, zoom: 1, x: 0, y: 0, baseW: 0, baseH: 0 };

  function openCropper(file, target) {
    if (!cropper || !cropImg) return;
    state.file = file;
    state.target = target;
    var reader = new FileReader();
    reader.onload = function (e) {
      cropImg.onload = function () {
        var size = cropStage.clientWidth;
        var scale = Math.max(size / cropImg.naturalWidth, size / cropImg.naturalHeight);
        state.baseW = cropImg.naturalWidth * scale;
        state.baseH = cropImg.naturalHeight * scale;
        state.zoom = 1;
        state.x = (size - state.baseW) / 2;
        state.y = (size - state.baseH) / 2;
        if (zoomInput) zoomInput.value = "1";
        applyTransform();
      };
      cropImg.src = e.target.result;
      cropper.classList.add("is-open");
      document.body.style.overflow = "hidden";
    };
    reader.readAsDataURL(file);
  }

  function applyTransform() {
    if (!cropImg) return;
    cropImg.style.width = state.baseW * state.zoom + "px";
    cropImg.style.height = state.baseH * state.zoom + "px";
    cropImg.style.left = state.x + "px";
    cropImg.style.top = state.y + "px";
  }

  function closeCropper() {
    if (!cropper) return;
    cropper.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  if (zoomInput) {
    zoomInput.addEventListener("input", function () {
      var size = cropStage.clientWidth;
      var prev = state.zoom;
      state.zoom = parseFloat(zoomInput.value);
      var cx = size / 2;
      state.x = cx - ((cx - state.x) / prev) * state.zoom;
      state.y = cx - ((cx - state.y) / prev) * state.zoom;
      applyTransform();
    });
  }

  if (cropStage) {
    var dragging = false;
    var start = { x: 0, y: 0 };
    cropStage.addEventListener("pointerdown", function (e) {
      dragging = true;
      start.x = e.clientX - state.x;
      start.y = e.clientY - state.y;
      cropStage.setPointerCapture(e.pointerId);
    });
    cropStage.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      state.x = e.clientX - start.x;
      state.y = e.clientY - start.y;
      applyTransform();
    });
    cropStage.addEventListener("pointerup", function () {
      dragging = false;
    });
  }

  var cancelBtn = document.querySelector("[data-crop-cancel]");
  if (cancelBtn) cancelBtn.addEventListener("click", closeCropper);

  var confirmBtn = document.querySelector("[data-crop-confirm]");
  if (confirmBtn) {
    confirmBtn.addEventListener("click", function () {
      var out = 900;
      var size = cropStage.clientWidth;
      var canvas = document.createElement("canvas");
      canvas.width = out;
      canvas.height = out;
      var ctx = canvas.getContext("2d");
      var ratio = out / size;
      ctx.drawImage(
        cropImg,
        state.x * ratio,
        state.y * ratio,
        state.baseW * state.zoom * ratio,
        state.baseH * state.zoom * ratio
      );
      canvas.toBlob(
        function (blob) {
          var name = (state.file.name || "slika").replace(/\.[^.]+$/, "") + "-crop.jpg";
          var cropped = new File([blob], name, { type: "image/jpeg" });
          applyCropped(state.target, cropped, canvas.toDataURL("image/jpeg", 0.9));
          closeCropper();
        },
        "image/jpeg",
        0.9
      );
    });
  }

  function applyCropped(target, file, dataUrl) {
    var wrap = document.querySelector('[data-upload="' + target + '"]');
    if (!wrap) return;
    var hiddenInput = wrap.querySelector("[data-upload-input]");
    try {
      var dt = new DataTransfer();
      dt.items.add(file);
      hiddenInput.files = dt.files;
    } catch (err) {
      /* stariji browseri: original ostaje */
    }
    var preview = wrap.querySelector("[data-upload-preview]");
    if (preview) preview.classList.remove("hidden");
    wrap.querySelectorAll("[data-upload-art]").forEach(function (img) {
      img.src = dataUrl;
    });
    var nameEl = wrap.querySelector("[data-upload-name]");
    if (nameEl) nameEl.textContent = file.name;
    var label = wrap.querySelector("[data-upload-label]");
    var btn = wrap.querySelector(".file-btn");
    if (label) label.textContent = (btn && btn.getAttribute("data-label-change")) || "Promeni fotografiju";
    wrap.dataset.hasImage = "true";
    refreshAddLabel();
  }

  document.querySelectorAll("[data-upload]").forEach(function (wrap) {
    var picker = wrap.querySelector("[data-upload-picker]");
    if (picker) {
      picker.addEventListener("change", function (e) {
        var file = e.target.files && e.target.files[0];
        e.target.value = "";
        if (file) openCropper(file, wrap.dataset.upload);
      });
    }
    var recrop = wrap.querySelector("[data-upload-recrop]");
    if (recrop) {
      recrop.addEventListener("click", function () {
        var input = wrap.querySelector("[data-upload-input]");
        if (input && input.files && input.files[0]) {
          openCropper(input.files[0], wrap.dataset.upload);
        }
      });
    }
    var remove = wrap.querySelector("[data-upload-remove]");
    if (remove) {
      remove.addEventListener("click", function () {
        var input = wrap.querySelector("[data-upload-input]");
        if (input) input.value = "";
        wrap.dataset.hasImage = "false";
        var preview = wrap.querySelector("[data-upload-preview]");
        if (preview) preview.classList.add("hidden");
        var label = wrap.querySelector("[data-upload-label]");
        var btn = wrap.querySelector(".file-btn");
        if (label) label.textContent = (btn && btn.getAttribute("data-label-pick")) || "Ubaci fotografiju";
        refreshAddLabel();
      });
    }
  });

  /* ---------------- Dugme „Dodaj u korpu" ---------------- */
  var addBtn = document.querySelector("[data-add-button]");
  var personalized = form && form.dataset.personalized === "true";

  function firstImageReady() {
    var wrap = document.querySelector('[data-upload="1"]');
    return !wrap || wrap.dataset.hasImage === "true";
  }
  function secondImageReady() {
    if (secondMode !== "different" || selectedPack() !== 2) return true;
    var wrap = document.querySelector('[data-upload="2"]');
    return !wrap || wrap.dataset.hasImage === "true";
  }

  /* natpis dugmeta dolazi iz jezičkog fajla preko data atributa, da ne ostane srpski na /de */
  function lbl(el, attr, rezerva) {
    var v = el && el.getAttribute(attr);
    return v && v.indexOf("translation missing") === -1 ? v : rezerva;
  }

  /* Forma pamti da li fotografija postoji — CSS na osnovu toga
     otvara ostatak koraka i sklanja veliko dugme. */
  function oznaciFotografiju() {
    if (!form || !personalized) return;
    form.dataset.hasPhoto = firstImageReady() ? "true" : "false";
  }

  var photoStart = document.querySelector("[data-photo-start]");
  if (photoStart) {
    photoStart.addEventListener("click", function () {
      var picker = document.querySelector('[data-upload="1"] [data-upload-picker]');
      if (picker) picker.click();
    });
  }

  function refreshAddLabel() {
    oznaciFotografiju();
    if (!addBtn || !personalized) return;
    if (!firstImageReady()) {
      addBtn.disabled = true;
      addBtn.textContent = lbl(addBtn, "data-label-need-image", "Prvo izaberite sliku");
      return;
    }
    if (!secondImageReady()) {
      addBtn.disabled = true;
      addBtn.textContent = lbl(addBtn, "data-label-need-image2", "Dodajte sliku za drugi komad");
      return;
    }
    addBtn.disabled = false;
    /* u korpu ide i zamenski uložak kad je čekiran, pa ulazi u brojač */
    var komada = selectedPack() + (addonIdFrom(form) ? 1 : 0);
    addBtn.textContent = lbl(addBtn, "data-label-add", "Dodaj u korpu") + " (" + komada + ")";
  }
  refreshAddLabel();

  /* čekiranje zamenskog uloška menja brojač na dugmetu */
  document.addEventListener("change", function (e) {
    if (e.target && e.target.closest && e.target.closest("[data-addon-toggle]")) refreshAddLabel();
  });

  /* ---------------- Kupi odmah ---------------- */
  var buyNow = document.querySelector("[data-buy-now]");
  function updateBuyNow() {
    if (!buyNow) return;
    var separate = personalized && selectedPack() === 2 && secondMode === "different";
    buyNow.classList.toggle("hidden", separate);
    var note = document.querySelector("[data-buy-note]");
    if (note) note.classList.toggle("hidden", !separate);
    if (personalized && selectedPack() === 2) {
      buyNow.textContent = lbl(buyNow, "data-label-buy2", "Kupi odmah — 2 komada");
    } else {
      buyNow.textContent = lbl(buyNow, "data-label-buy", "Kupi odmah");
    }
  }
  updateBuyNow();

  if (buyNow && form) {
    buyNow.addEventListener("click", function (e) {
      e.preventDefault();

      // Ako su čekirani dodatni ulošci, obe stavke idu u korpu pa tek onda na plaćanje.
      if (addonIdFrom(form)) {
        buyNow.disabled = true;
        var data = new FormData(form);
        data.delete("checkout");
        fetch((window.SENSEI.routes.cartAdd || "/cart/add") + ".js", { method: "POST", body: data })
          .then(function (r) {
            if (!r.ok) throw new Error("add failed");
            return addAddonFrom(form);
          })
          .then(function () {
            window.location.href = "/checkout";
          })
          .catch(function () {
            buyNow.disabled = false;
            form.submit();
          });
        return;
      }

      var checkoutInput = form.querySelector('[name="checkout"]');
      if (!checkoutInput) {
        checkoutInput = document.createElement("input");
        checkoutInput.type = "hidden";
        checkoutInput.name = "checkout";
        checkoutInput.value = "1";
        form.appendChild(checkoutInput);
      }
      form.submit();
    });
  }

  /* -------- Dodatna ponuda (npr. zamenski ulošci) — važi za SVE načine kupovine -------- */
  function addonIdFrom(f) {
    var t = f ? f.querySelector("[data-addon-toggle]") : null;
    var v = f ? f.querySelector("[data-addon-variant]") : null;
    return t && t.checked && v && v.value ? Number(v.value) : null;
  }
  function addAddonFrom(f) {
    var id = addonIdFrom(f);
    if (!id) return Promise.resolve();
    return fetch((window.SENSEI.routes.cartAdd || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    });
  }

  /* -------- Dva različita komada: drugi komad kao odvojena linija -------- */
  if (form) {
    form.addEventListener("submit", function (e) {
      var separate = personalized && selectedPack() === 2 && secondMode === "different";
      if (!separate) return;
      e.preventDefault();
      if (qtyInput) qtyInput.value = "1";
      var data1 = new FormData(form);
      var second = document.querySelector("[data-second-fields]");
      var data2 = new FormData(form);
      data2.set("quantity", "1");
      if (second) {
        var scent2 = second.querySelector("[data-second-scent]");
        if (scent2) data2.set("properties[Parfem]", scent2.value);
        var color2 = second.querySelector("[data-color-input]");
        if (color2 && color2.value) data2.set("properties[Boja]", color2.value);
        var file2 = document.querySelector('[data-upload="2"] [data-upload-input]');
        if (file2 && file2.files && file2.files[0]) {
          data2.set("properties[Slika]", file2.files[0]);
        }
      }
      data2.delete("checkout");
      data1.delete("checkout");
      var add = window.SENSEI.routes.cartAdd;
      fetch(add, { method: "POST", body: data1 })
        .then(function () {
          return fetch(add, { method: "POST", body: data2 });
        })
        .then(function () {
          return addAddonFrom(form);
        })
        .then(function () {
          if (window.SENSEI.openCartDrawer) return window.SENSEI.openCartDrawer();
          window.location.href = window.SENSEI.routes.cart;
        })
        .catch(function () {
          window.location.href = window.SENSEI.routes.cart;
        });
    });
  }
})();

/* ============================================================
   KORPA SA STRANE (drawer)
   ============================================================ */
(function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  var routes = (window.SENSEI && window.SENSEI.routes) || {};
  var addUrl = (routes.cartAdd || "/cart/add") + ".js";
  var changeUrl = (routes.cartChange || "/cart/change") + ".js";
  var cartUrl = routes.cart || "/cart";

  function openDrawer() {
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-open");
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-open");
  }

  function setBusy(state) {
    drawer.classList.toggle("is-busy", state);
  }

  function syncHeaderCount() {
    var badge = drawer.querySelector(".cart-drawer__count");
    if (!badge) return;
    var text = badge.textContent.replace(/[()\s]/g, "");
    document.querySelectorAll(".cart-link").forEach(function (el) {
      el.textContent = "Korpa (" + text + ")";
    });
  }

  function refresh() {
    return fetch(window.location.pathname + "?sections=cart-drawer", {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.querySelector("[data-cart-drawer]");
        if (!fresh) return;
        drawer.innerHTML = fresh.innerHTML;
        syncHeaderCount();
      });
  }

  function changeLine(line, quantity) {
    setBusy(true);
    return fetch(changeUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return refresh(); })
      .catch(function () { window.location.href = cartUrl; })
      .then(function () { setBusy(false); });
  }

  /* ---- korpa u zaglavlju vodi na stranicu korpe (kao na uzoru) ---- */

  /* ---- klikovi unutar drawer-a ---- */
  drawer.addEventListener("click", function (e) {
    if (!e.target.closest) return;

    if (e.target.closest("[data-cart-close]")) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest("[data-cart-remove]");
    if (removeBtn) {
      e.preventDefault();
      var lineEl = removeBtn.closest("[data-line-index]");
      if (lineEl) changeLine(parseInt(lineEl.dataset.lineIndex, 10), 0);
      return;
    }

    var stepBtn = e.target.closest("[data-qty-step]");
    if (stepBtn) {
      e.preventDefault();
      var row = stepBtn.closest("[data-line-index]");
      var input = row ? row.querySelector("[data-qty-input]") : null;
      if (!row || !input) return;
      var next = parseInt(input.value, 10) + parseInt(stepBtn.dataset.qtyStep, 10);
      if (next < 0) next = 0;
      changeLine(parseInt(row.dataset.lineIndex, 10), next);
    }
  });

  drawer.addEventListener("change", function (e) {
    var input = e.target.closest ? e.target.closest("[data-qty-input]") : null;
    if (!input) return;
    var row = input.closest("[data-line-index]");
    if (!row) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 0) value = 1;
    changeLine(parseInt(row.dataset.lineIndex, 10), value);
  });

  /* ---- dodatna ponuda: prikaži izbor mirisa kad se čekira ---- */
  document.addEventListener("change", function (e) {
    var toggle = e.target.closest ? e.target.closest("[data-addon-toggle]") : null;
    if (!toggle) return;
    var block = toggle.closest("[data-addon-block]");
    var fields = block ? block.querySelector("[data-addon-fields]") : null;
    if (fields) fields.classList.toggle("hidden", !toggle.checked);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer();
  });

  /* ---- dodavanje u korpu bez napuštanja stranice ---- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (e.defaultPrevented) return;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.querySelector('[name="checkout"]')) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Dodajem…"; }

    var addonToggle = form.querySelector("[data-addon-toggle]");
    var addonVariant = form.querySelector("[data-addon-variant]");
    var addonId =
      addonToggle && addonToggle.checked && addonVariant && addonVariant.value
        ? addonVariant.value
        : null;

    var added = null;
    fetch(addUrl, { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json().catch(function () { return {}; });
      })
      .then(function (item) {
        added = item;
        if (!addonId) return null;
        return fetch(addUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(addonId), quantity: 1 }] })
        });
      })
      .then(
        function () {
          return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .catch(function () { return null; })
            .then(function (cart) {
              if (window.SENSEI.showAdded && added) window.SENSEI.showAdded(window.SENSEI.addedFromItem(added, cart ? cart.item_count : null));
              else window.location.href = cartUrl;
            });
        },
        function () { form.submit(); }
      )
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* ---- koristi ga i logika za dva različita komada ---- */
  window.SENSEI.openCartDrawer = function () {
    return refresh().then(openDrawer);
  };
})();

/* ============================================================
   IZBOR BOJE KUĆIŠTA (personalizovani proizvod)
   ============================================================ */
(function () {
  document.addEventListener("click", function (e) {
    var sw = e.target.closest ? e.target.closest("[data-color-swatch]") : null;
    if (!sw) return;
    var block = sw.closest("[data-color-block]");
    if (!block) return;

    block.querySelectorAll("[data-color-swatch]").forEach(function (b) {
      b.classList.remove("is-active");
      b.setAttribute("aria-pressed", "false");
    });
    sw.classList.add("is-active");
    sw.setAttribute("aria-pressed", "true");

    var name = sw.getAttribute("data-color") || "";
    var input = block.querySelector("[data-color-input]");
    if (input) input.value = name;
    var label = block.querySelector("[data-color-label]");
    if (label) label.textContent = name;

    applyMockup(sw, block);
  });

  /* ---- pregled u izabranoj boji ---- */
  function applyMockup(sw, block) {
    var url = sw.getAttribute("data-mockup");
    if (!url) return;
    var scope = block.closest("[data-second-fields]")
      ? '[data-upload="2"]'
      : '[data-upload="1"]';
    document.querySelectorAll(scope + " .mockup__base").forEach(function (img) {
      img.src = url;
    });
  }

  /* ---- na učitavanju stranice postavi mockup izabrane boje ---- */
  document.querySelectorAll("[data-color-block]").forEach(function (block) {
    var active = block.querySelector("[data-color-swatch].is-active");
    if (active) applyMockup(active, block);
  });
})();

/* ---------- Prekidač za jezik i državu ---------- */
document.addEventListener("change", function (e) {
  var el = e.target;
  if (el && el.matches && el.matches("[data-loc-select]") && el.form) {
    el.form.submit();
  }
});


/* ============================================================
   POTVRDA „DODATO U KORPU“ (odozdo, kao na uzoru)
   ============================================================ */
(function () {
  window.SENSEI = window.SENSEI || {};
  function money(cents) {
    var f = String(window.SENSEI.moneyFormat || "{{amount}}").replace(/<[^>]*>/g, "");
    var n = Number(cents || 0) / 100;
    function d(x, dec, th, ds) {
      var p = x.toFixed(dec).split(".");
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return dec ? p[0] + ds + p[1] : p[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === "amount_no_decimals") return d(n, 0, ",", ".");
      if (k === "amount_with_comma_separator") return d(n, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return d(n, 0, ".", ",");
      if (k === "amount_with_apostrophe_separator") return d(n, 2, "'", ".");
      return d(n, 2, ",", ".");
    }).replace(/([.,])00(?!\d)/, "");
  }
  window.SENSEI.formatMoney = money;
  window.SENSEI.syncCartCount = function (count) {
    if (typeof count !== "number") return;
    window.SENSEI.cartCount = count;
    document.querySelectorAll(".cart-link, a.small-caps[href$='/cart']").forEach(function (a) {
      if (/\(\d+\)/.test(a.textContent)) a.textContent = a.textContent.replace(/\(\d+\)/, "(" + count + ")");
    });
  };
  window.SENSEI.addedFromItem = function (item, count) {
    var vt = item.variant_title && !/default/i.test(item.variant_title) ? item.variant_title : "";
    /* isto čišćenje kao snippet scent-name: bez kružića i oznaka (Eros)/(Million) */
    vt = vt.replace(/[\u{1F534}\u{26AB}\u{1F7E1}\u{1F7E2}\u{1F7E3}\u{1F518}️]/gu, "").replace(/\(\s*(eros|mill?ion)\s*\)/gi, "").replace(/\s+/g, " ").trim();
    return {
      image: item.image || item.featured_image && item.featured_image.url || "",
      name: item.product_title || item.title || "",
      meta: vt,
      price: money(item.final_price != null ? item.final_price : item.price),
      compare: item.original_price > item.final_price ? money(item.original_price) : "",
      count: count
    };
  };

  var sheet = document.querySelector("[data-added-sheet]");
  if (!sheet) return;
  var lastFocus = null, timer = 0;
  function close() {
    sheet.classList.remove("is-open");
    document.body.classList.remove("added-open");
    clearTimeout(timer);
    timer = setTimeout(function () { if (!sheet.classList.contains("is-open")) sheet.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.SENSEI.showAdded = function (d) {
    d = d || {};
    var img = sheet.querySelector("[data-added-img]");
    if (img) { img.src = d.image || ""; img.parentNode.hidden = !d.image; }
    sheet.querySelector("[data-added-name]").textContent = d.name || "";
    var meta = sheet.querySelector("[data-added-meta]");
    meta.textContent = d.meta || ""; meta.hidden = !d.meta;
    var cmp = sheet.querySelector("[data-added-compare]");
    cmp.textContent = d.compare || ""; cmp.hidden = !d.compare;
    sheet.querySelector("[data-added-price]").textContent = d.price || "";
    if (typeof d.count === "number") {
      sheet.querySelector("[data-added-count]").textContent = d.count;
      window.SENSEI.syncCartCount(d.count);
    }
    lastFocus = document.activeElement;
    clearTimeout(timer);
    sheet.hidden = false;
    void sheet.offsetWidth;
    sheet.classList.add("is-open");
    document.body.classList.add("added-open");
    var x = sheet.querySelector(".added-sheet__x");
    if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
  };
  sheet.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest("[data-added-close]")) { e.preventDefault(); close(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && sheet.classList.contains("is-open")) close();
  });
})();

/* ============================================================
   KORPA STRANICA: količina, brisanje, ponuda uložaka, kod za popust
   (bez osvežavanja — sekcija se ponovo iscrta)
   ============================================================ */
(function () {
  var root = document.querySelector("[data-vc-cart]");
  if (!root) return;
  var routes = (window.SENSEI && window.SENSEI.routes) || {};
  var cartUrl = routes.cart || "/cart";
  var changeUrl = (routes.cartChange || "/cart/change") + ".js";
  var addUrl = (routes.cartAdd || "/cart/add") + ".js";
  var updateUrl = cartUrl + "/update.js";
  var sid = root.dataset.section;

  function busy(on) { root.classList.toggle("is-busy", on); }
  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || "Greška");
        return data;
      });
    });
  }
  function render() {
    return fetch(cartUrl + "?section_id=" + encodeURIComponent(sid), { headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var fresh = tmp.querySelector("[data-vc-cart]");
        if (!fresh) { window.location.reload(); return; }
        root.innerHTML = fresh.innerHTML;
        root.dataset.count = fresh.dataset.count;
        var count = parseInt(fresh.dataset.count, 10);
        if (!isNaN(count) && window.SENSEI.syncCartCount) window.SENSEI.syncCartCount(count);
      });
  }
  function msg(text, ok) {
    var el = root.querySelector("[data-vc-code-msg]");
    if (!el) return;
    el.textContent = text || "";
    el.hidden = !text;
    el.classList.toggle("is-ok", !!ok);
  }
  function run(promise) {
    busy(true);
    return promise.then(render).catch(function (err) { msg(err && err.message ? err.message : "Greška", false); }).then(function () { busy(false); });
  }

  root.addEventListener("click", function (e) {
    if (!e.target.closest || root.classList.contains("is-busy")) return;
    var qty = e.target.closest("[data-vc-qty]");
    var rm = e.target.closest("[data-vc-remove]");
    if (qty || rm) {
      var line = e.target.closest("[data-line]");
      if (!line) return;
      var next = rm ? 0 : Math.max(0, parseInt(line.dataset.qty, 10) + parseInt(qty.dataset.vcQty, 10));
      run(post(changeUrl, { line: parseInt(line.dataset.line, 10), quantity: next }));
      return;
    }
    var add = e.target.closest("[data-vc-add]");
    if (add) {
      run(post(addUrl, { items: [{ id: Number(add.dataset.vcAdd), quantity: 1 }] }));
      return;
    }
    var un = e.target.closest("[data-vc-uncode]");
    if (un) {
      run(post(updateUrl, { discount: "" }));
      return;
    }
    if (e.target.closest("[data-vc-apply]")) applyCode();
  });
  root.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.matches && e.target.matches("[data-vc-code]")) { e.preventDefault(); applyCode(); }
  });

  function applyCode() {
    var input = root.querySelector("[data-vc-code]");
    var code = input ? input.value.trim() : "";
    if (!code) return;
    busy(true);
    post(updateUrl, { discount: code })
      .then(function (cart) {
        var list = cart && cart.discount_codes;
        if (!Array.isArray(list)) {
          window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(cartUrl);
          return;
        }
        var hit = list.filter(function (d) { return String(d.code).toLowerCase() === code.toLowerCase(); })[0];
        /* nevažeći kod ne ostaje zakačen za korpu */
        var cleanup = hit && hit.applicable ? Promise.resolve() : post(updateUrl, { discount: list.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }).join(",") }).catch(function () {});
        return cleanup.then(render).then(function () {
          var m = root.querySelector("[data-vc-code-msg]");
          var d = m ? m.dataset : {};
          if (hit && hit.applicable) msg(d.ok || "Kod je primenjen.", true);
          else msg(d.bad || "Kod nije važeći za ovu korpu.", false);
        });
      })
      .catch(function (err) { msg(err && err.message ? err.message : "Greška", false); })
      .then(function () { busy(false); });
  }
})();


/* ============================================================
   PODELI — telefon otvara svoj meni (WhatsApp, Viber, Instagram…);
   računar dobija naš meni. Dizajn se deli kao slika + link.
   ============================================================ */
(function () {
  window.SENSEI = window.SENSEI || {};
  var sheet = document.querySelector("[data-share-sheet]");
  var current = null, imgUrl = null;
  function close() {
    if (!sheet) return;
    sheet.classList.remove("is-open");
    document.body.classList.remove("added-open");
    setTimeout(function () { if (!sheet.classList.contains("is-open")) sheet.hidden = true; }, 260);
  }
  function openSheet(d) {
    if (!sheet) { window.prompt("Link:", d.url); return; }
    current = d;
    var full = (d.text ? d.text + " " : "") + d.url;
    sheet.querySelector("[data-share-wa]").href = "https://wa.me/?text=" + encodeURIComponent(full);
    sheet.querySelector("[data-share-viber]").href = "viber://forward?text=" + encodeURIComponent(full);
    sheet.querySelector("[data-share-fb]").href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(d.url);
    var img = sheet.querySelector("[data-share-img]"), dl = sheet.querySelector("[data-share-dl]");
    if (imgUrl) { URL.revokeObjectURL(imgUrl); imgUrl = null; }
    if (d.file) { imgUrl = URL.createObjectURL(d.file); img.src = imgUrl; dl.href = imgUrl; }
    img.hidden = !d.file; dl.hidden = !d.file;
    var msg = sheet.querySelector("[data-share-msg]"); msg.hidden = true;
    sheet.hidden = false; void sheet.offsetWidth;
    sheet.classList.add("is-open");
    document.body.classList.add("added-open");
  }
  window.SENSEI.share = function (d) {
    d = d || {};
    d.url = d.url || location.href;
    var full = (d.text ? d.text + " " : "") + d.url;
    var touch = window.matchMedia && matchMedia("(pointer: coarse)").matches;
    var fallback = function (e) { if (e && e.name === "AbortError") return; openSheet(d); };
    try {
      if (touch && d.file && navigator.canShare && navigator.canShare({ files: [d.file] })) {
        return navigator.share({ files: [d.file], title: d.title, text: full }).catch(fallback);
      }
      if (touch && navigator.share) {
        return navigator.share({ title: d.title, text: d.text, url: d.url }).catch(fallback);
      }
    } catch (e) {}
    openSheet(d);
  };
  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest("[data-share-link]");
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var u = b.getAttribute("data-url") || location.pathname;
      window.SENSEI.share({ title: b.getAttribute("data-title") || document.title, url: new URL(u, location.origin).href });
    }
  });
  if (!sheet) return;
  sheet.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    if (e.target.closest("[data-share-close]")) { e.preventDefault(); close(); return; }
    if (e.target.closest("[data-share-copy]") && current) {
      var msg = sheet.querySelector("[data-share-msg]");
      var done = function () { msg.textContent = msg.getAttribute("data-ok") || "Link je kopiran."; msg.hidden = false; };
      var ok = false;
      try {
        var ta = document.createElement("textarea");
        ta.value = (current.text ? current.text + " " : "") + current.url; ta.setAttribute("readonly", ""); ta.style.cssText = "position:fixed;top:-1000px;left:0;opacity:0";
        document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, ta.value.length);
        ok = document.execCommand("copy"); ta.remove();
      } catch (err) {}
      if (!ok && navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText((current.text ? current.text + " " : "") + current.url).catch(function () {}); ok = true; }
      if (ok) done(); else window.prompt("Link:", current.url);
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && sheet.classList.contains("is-open")) close(); });
})();


/* ============================================================
   „Kreiraj svoj Sensei“ (bilo gde): odmah bira fotografiju, [KREIRAJ SVOJ SENSEI_HANDOFF]
   pa otvara proizvod gde se mockup pravi bez čekanja.
   Fotografija se predaje preko IndexedDB (sensei-handoff) + ?foto=1.
   ============================================================ */
(function () {
  var input = null, active = null;
  function save(rec) {
    return new Promise(function (res) {
      try {
        var r = indexedDB.open('sensei-handoff', 1);
        r.onupgradeneeded = function () { r.result.createObjectStore('files'); };
        r.onerror = function () { res(false); };
        r.onsuccess = function () {
          var db = r.result, tx = db.transaction('files', 'readwrite');
          tx.objectStore('files').put(rec, 'photo');
          tx.oncomplete = function () { db.close(); res(true); };
          tx.onerror = tx.onabort = function () { res(false); };
        };
      } catch (e) { res(false); }
    });
  }
  function ensureInput() {
    if (input) return input;
    input = document.createElement('input');
    input.type = 'file'; input.accept = 'image/*,.heic,.heif,.avif,.jfif'; input.hidden = true;
    document.body.appendChild(input);
    input.addEventListener('change', function () {
      var f = input.files && input.files[0], btn = active; if (!f || !btn) return;
      /* konfigurator je na ovoj stranici: mockup se pravi tu, bez prelaska */
      var host = document.querySelector('sensei-shopify');
      if (host && typeof host.sendPhoto === 'function') {
        var lbl = btn.querySelector('span');
        btn.disabled = true; btn.classList.add('is-busy');
        if (lbl && btn.getAttribute('data-busy')) { lbl.setAttribute('data-orig', lbl.textContent); lbl.textContent = btn.getAttribute('data-busy'); }
        f.arrayBuffer().then(function (buf) { return new File([buf], f.name || 'fotografija.jpg', { type: f.type || '', lastModified: f.lastModified || Date.now() }); })
          .catch(function () { return f; })
          .then(function (file) { input.value = ''; if (host.status) host.status(''); return host.sendPhoto(file); })
          .then(function () { if (btn.getAttribute('data-miris') && host.dataset.stage === 'studio' && host.applyLook) host.applyLook({ 'Miris': btn.getAttribute('data-miris') }); })
          .catch(function () {})
          .then(function () {
            btn.disabled = false; btn.classList.remove('is-busy');
            if (lbl && lbl.getAttribute('data-orig')) lbl.textContent = lbl.getAttribute('data-orig');
            /* slika nije uspela: pokaži konfigurator sa porukom o grešci */
            if (host.dataset.stage !== 'studio' && host.hasAttribute('data-hidden-intro')) {
              host.removeAttribute('data-hidden-intro');
              host.scrollIntoView({ block: 'start' });
            }
          });
        return;
      }
      var url = (btn.getAttribute('data-url') || '/').trim();
      var label = btn.querySelector('span');
      btn.disabled = true; btn.classList.add('is-busy');
      if (label) { label.setAttribute('data-orig', label.textContent); label.textContent = btn.getAttribute('data-busy') || label.textContent; }
      f.arrayBuffer().then(function (buf) { return save({ buf: buf, name: f.name, type: f.type, at: Date.now() }); })
        .catch(function () { return false; })
        .then(function (ok) { input.value = ''; location.href = ok ? url + (url.indexOf('?') < 0 ? '?' : '&') + 'foto=1' : url; });
    });
    return input;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-photo-start]') : null;
    if (!b || b.disabled) return;
    e.preventDefault(); active = b; ensureInput().click();
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-photo-start].is-busy').forEach(function (b) {
      b.disabled = false; b.classList.remove('is-busy');
      var l = b.querySelector('span'); if (l && l.getAttribute('data-orig')) l.textContent = l.getAttribute('data-orig');
    });
  });
})();


/* ============================================================
   KORPA → „Dodaj N. komad“: nazad na stranicu na kojoj je kupac poslednji put dodao komad
   (Porodica, Ljubimac, Dete, Vas dvoje, početna), sa otvorenim mockupom (?dizajn=1).
   Pregledač pamti stranicu pri svakom dodavanju; ako je nema, važi link iz korpe.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a.vc-box') : null;
    if (!a) return;
    var last = null;
    try { last = JSON.parse(localStorage.getItem('sensei-strana') || 'null'); } catch (err) {}
    if (!last || !last.p || last.p.charAt(0) !== '/' || Date.now() - (last.t || 0) > 30 * 864e5) return;
    var cilj = last.p + (last.p.indexOf('?') < 0 ? '?' : '&');
    if (a.hasAttribute('data-photo-start')) { a.setAttribute('data-url', cilj + 'izgled=1'); return; }
    e.preventDefault();
    location.href = cilj + 'dizajn=1';
  });
})();


/* ============================================================
   Zaglavlje kao na uzoru: pri skrolovanju na vrhu ostaje samo traka obaveštenja,
   meni odlazi sa stranicom (lepljivi deo se pomeri gore tačno za visinu menija).
   ============================================================ */
(function () {
  var s = document.getElementById('shopify-section-header'), a = s && s.querySelector('.announcement');
  if (!s || !a) return;
  function set() { s.style.setProperty('--ann-h', a.offsetHeight + 'px'); }
  set(); window.addEventListener('resize', set);
  if (window.ResizeObserver) new ResizeObserver(set).observe(a);
})();
